import { COOKIE_MANAGEMENT_NAME, getCookie } from './cookie-helpers'

export interface CookieConsent {
  trackingCookies: boolean
  recordingCookies: boolean
}

export const COOKIE_BANNER_ID = 'cookie-banner'
export const COOKIE_CONSENT_UPDATED_EVENT = 'tc_cookie_manager_updated'

export const parseCookieConsent = (
  cookieValue: string,
): CookieConsent | null => {
  try {
    return JSON.parse(decodeURIComponent(cookieValue))
  } catch (error) {
    console.error('Error parsing cookie management cookie:', error)
    return null
  }
}

export const getCookieConsent = () => {
  const cookieValue = getCookie(COOKIE_MANAGEMENT_NAME)
  return cookieValue ? parseCookieConsent(cookieValue) : null
}

export const isCookieBannerOnPage = () =>
  document.getElementById(COOKIE_BANNER_ID) !== null

export const onCookieConsentUpdated = (
  callback: (consent: CookieConsent) => void,
) => {
  const handleConsentUpdated = (event: Event) =>
    callback((event as CustomEvent<CookieConsent>).detail)

  window.addEventListener(COOKIE_CONSENT_UPDATED_EVENT, handleConsentUpdated)

  return () =>
    window.removeEventListener(
      COOKIE_CONSENT_UPDATED_EVENT,
      handleConsentUpdated,
    )
}
